/** Spanish. Missing keys fall back to English. */
import type { en } from './en';

type Partial<T> = { [P in keyof T]?: T[P] };

export const es: Partial<typeof en> = {
  'nav.features':  'Funciones',
  'nav.pricing':   'Precios',
  'nav.templates': 'Plantillas',
  'nav.blog':      'Blog',
  'nav.login':     'Iniciar sesión',
  'nav.register':  'Obtén MyDay gratis',

  'hero.badge':    'Novedad — el asistente de IA crea tableros por ti',
  'hero.title.a':  'El',
  'hero.title.b':  'nuevo favorito',
  'hero.title.c':  'de tu equipo.',
  'hero.subtitle': 'Todo lo que tiene Monday.com, con un toque de neón, un poco de pastel y una IA que de verdad trabaja contigo. Planifica, organiza y entrega — en equipo.',
  'hero.cta.primary':   'Obtén MyDay gratis',
  'hero.cta.secondary': 'Ver todas las funciones',
  'hero.notice':        'Sin tarjeta · Plan gratuito para siempre · Listo en 3 minutos',

  'auth.login.title':    'Bienvenida de vuelta.',
  'auth.login.subtitle': 'Qué bueno verte. Empecemos el día.',
  'auth.register.title': 'Haz MyDay tuyo.',
  'auth.register.subtitle': '3 minutos hasta tu primer tablero. Sin tarjeta, sin letra pequeña.',

  'common.cancel': 'Cancelar',
  'common.save':   'Guardar',
  'common.delete': 'Eliminar',
  'common.new':    'Nuevo',
};
